<template>
  <div>
    <v-tooltip bottom open-delay="500">
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon class="mx-1" v-bind="attrs" v-on="on" @click="exportar">
          <v-icon>$MicrosoftExcel</v-icon>
        </v-btn>
      </template>
      <span>Exportar para excel</span>
    </v-tooltip>

    <form
      :action="URL"
      method="post"
      target="_blank"
      ref="submit-exportacao-grid-para-excel"
    >
      <input type="text" hidden name="items" :value="JSON.stringify(items)" />
      <input type="text" hidden name="parametros_excel" :value="JSON.stringify(parametros_excel)" />
    </form>

  </div>
</template>

<script>
import $axios from '@/api/api.js';

export default {
  name: "ExportacaoGridParaExcel",
  props: {
    url: String,
    items: Array,
    parametros_excel: Array
  },
  computed: {
    URL(){
      return `${$axios.defaults.baseURL}/${this.url}`;
    }
  },
  methods: {
    exportar() {
      this.$refs['submit-exportacao-grid-para-excel'].submit();
    }
  }
}
</script>

<style scoped>

</style>
